/**
 * Organisationen, Mitgliedschaften und die Betreiberebene darüber.
 *
 * Ein Konto gehört einem Menschen, nicht einer Firma. Die Verbindung zwischen
 * beidem ist die Mitgliedschaft — deshalb kann dieselbe Anmeldung in mehreren
 * Organisationen stehen und zwischen ihnen wechseln, ohne sich neu anzumelden.
 */
/**
 * Beschriftungen als Textschlüssel statt als fertige Sätze: Was es gibt, steht
 * hier; wie es heißt, steht im Wörterbuch. Aufrufer schreiben `t(ORG_ROLE_LABEL[role])`.
 */
export const ORG_ROLE_LABEL = {
    admin: 'role.admin',
    member: 'role.member',
};
export const ORG_ROLE_HINT = {
    admin: 'role.admin.hint',
    member: 'role.member.hint',
};
export const VISIBILITY_LABEL = {
    private: 'visibility.private',
    organisation: 'visibility.organisation',
};
//# sourceMappingURL=org.js.map